<template>
  <el-main class="page-content-margin-unset">
    <el-upload
      class="upload-demo"
      :action="uploadDomain"
      :on-change="handleChange"
      :on-remove="removeImgImages"
      :before-upload="beforeAvatarUploadImages"
      :on-success="onImageUploadSuccessImages"
      :data="uploadData"
      multiple
      :file-list="ImagesList">
      <el-button
        size="small"
        type="primary">点击上传</el-button>
      <div
        slot="tip"
        class="el-upload__tip">只能上传jpg/png文件，且不超过2mb</div>
    </el-upload>
  </el-main>
</template>

<script>
import { uploadDomain } from '../../configs/env'
import { getQiniuToken } from '../../api/common';

export default {
  data() {
    return {
      uploadDomain,
      uploadData: {
        token: '',
        saveKey: '',
        key: '',
      },
      ImagesList: [],
    };
  },
  created() {
    this.getQiniuToken();
  },
  methods: {
    async getQiniuToken() {
      const { status, data } = await getQiniuToken()
      if (status !== 200) return
      this.uploadData.token = data.token
    },
    handleChange(file, fileList) {
      this.ImagesList = fileList;
    },
    beforeAvatarUploadImages(file) {
      console.log(file);
      this.uploadData.saveKey = file.name
      this.uploadData.key = file.name
      // const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      // console.log(file.type, '------------------');

      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      //   this.$message.error('上传视频只能是mp4格式!');
      // }
      // if (!isLt2M) {
      //   this.$message.error('上传视频大小不能超过 2MB!');
      // }
      // return isLt2M && isJPG;
    },
    onImageUploadSuccessImages(response) {
      this.ImagesList.push({
        response: {
          hash: response.hash,
        }, // response里面的hash是必须的
        url: this.imgDomain + response.hash, // url也是必须的
      })
    },
    removeImgImages(file, fileList) {
      this.ImagesList = fileList // 剩下的文件
      // eslint-disable-next-line
    },
  },
  components: {
  },
};
</script>

<style scoped lang="scss">
.page-content-margin-unset{
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/upload/upload.vue